import { HTTPRequestMethods } from "../../Shared/httpRequestMethods";
import { parseJsonResponse } from "../../Shared/parseJsonResponse";
import { convertObjectKeysToSnakeCase } from "../../Shared/ConvertObjectKeysToSnakeCase";

export const getSessionTokens = ({ pageNumber, onResponse, onError }) => {
  fetch(
    `/api/session_tokens/?page_number=${pageNumber}`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const deleteSessionToken = ({ sessionTokenId, pageNumber, onResponse, onError, body }) => {
  fetch(
    `/api/session_tokens/${sessionTokenId}?page_number=${pageNumber}`,
    {
      method: HTTPRequestMethods.DELETE,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const deleteExpiredSessionTokens = ({ pageNumber, onResponse, onError, body }) => {
  fetch(
    `/api/session_tokens/destroy_expired?page_number=${pageNumber}`,
    {
      method: HTTPRequestMethods.DELETE,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
